import { useMemo } from 'react';

import { Select } from '@/lib/base/forms/select/select';
import { getPropertyTypeIconComponent } from '@/lib/crm/utils/icons/PropertyTypeIcon';
import {
  COMMON_LANGUAGES,
  getCanonicalLanguageCode,
} from '@/lib/crm/utils/language';

import type { PropertyInputProps } from './TextInput';

export const LanguageInput: React.FC<PropertyInputProps> = ({
  propertyType,
  value,
  onChange,
  disabled = false,
  inputRef,
  placeholder,
  size = 'sm',
}) => {
  const items = useMemo(
    () =>
      COMMON_LANGUAGES.map(lang => ({
        id: lang.code,
        label: `${lang.flag} ${lang.label}`,
        supportingText: lang.code,
      })),
    [] // COMMON_LANGUAGES is static, no dependencies needed
  );

  const Icon = getPropertyTypeIconComponent(propertyType);

  return (
    <Select.ComboBox
      placeholder={placeholder || 'Select language'}
      size={size}
      items={items}
      selectedKey={
        value !== null && value !== undefined
          ? getCanonicalLanguageCode(String(value))
          : null
      }
      onSelectionChange={key =>
        onChange(key !== null && key !== undefined ? String(key) : null)
      }
      isDisabled={disabled}
      shortcut={false}
      aria-label={propertyType.label}
      icon={Icon}
      ref={inputRef}
    >
      {item => (
        <Select.Item id={item.id} textValue={item.label}>
          {item.label}
          {item.supportingText && (
            <span className='text-text-tertiary ml-2 text-xs'>
              {item.supportingText}
            </span>
          )}
        </Select.Item>
      )}
    </Select.ComboBox>
  );
};
